export default "__VITE_ASSET__4fV5TSdf__"